import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const ProvinceDetails = ({
  selectedProvince,
  setSelectedProvince,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedProvince({});
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Province Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            "Province Name": selectedProvince?.province_name || "",
            "Country Name": selectedProvince?.country?.country_name || "",
            "Province Code": selectedProvince?.province_code || "",
            Status: selectedProvince?.status ? "Active" : "In Active",
            "Created At": selectedProvince?.createdAt
              ? format(selectedProvince?.createdAt, "PP")
              : "",
            "Updated At": selectedProvince?.updatedAt
              ? format(selectedProvince?.updatedAt, "PP")
              : "",
            "Deleted At": selectedProvince?.deletedAt
              ? format(selectedProvince?.deletedAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ProvinceDetails;
